import { styled } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';

export const StyledReportIcon = styled(ShareIcon)`
    margin-right: 5px;
    font-size: 17px;
`;